import type { Props } from "~/components/ui/BannerCarousel"
export { default, loader } from "~/components/ui/BannerCarousel"

// Above-the-fold: sem `sync` o DecoPageRenderer renderiza a section como
// `<Suspense fallback={null}>` + `React.lazy` e DESCARTA o `LoadingFallback`
// abaixo — o hero sai como `<template id="B:n">` de 0px e só resolve no último
// script do documento (LCP 2,2s + CLS 0,24). Mesmo defeito do #179.
export const sync = true

export function LoadingFallback(_props: Partial<Props>) {
  return (
    <div className='flex items-center justify-center w-full aspect-[768/500] lg:aspect-[1920/450] bg-gray-200 animate-pulse'>
      <span className='loading loading-spinner' />
    </div>
  )
}

// Sem `export const cache`: a section original não o tinha, e o cache de
// section é chaveado só por `component + hash(props CRUAS)` — sem UA. Se
// algum dia o loader voltar a derivar props do request, o primeiro visitante
// depois do TTL passa a definir a marcação de todo mundo.
